
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    name: 'ButtonGroup',
    components: {
        Icon
    },
    props: {
        leadingIcon: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        value: {
            type: [Boolean, String, Number],
            default: null
        },
        trailingIcon: {
            type: String,
            default: null
        },
        selectable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            isSelected: false
        }
    }
}
